import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ToggleButton from '@Components/Results/reactions/reaction-details/ToggleButton';
import ReactReactionDetailsHelper from '@Components/Results/services/react-reaction-details-helper.service';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

import './ReactionStageDetail.scss';

/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
export default class ReactionStageDetailComponent extends React.Component {
  static last(index, array) {
    return index === array.length - 1;
  }

  constructor(props) {
    super(props);

    this.state = {
      experimentalProcedureExpanded: false,
    };
  }

  // eslint-disable-next-line react/sort-comp,class-methods-use-this
  substanceClick(e, item, metadata) {
    e.preventDefault();
    ReactReactionDetailsHelper.goToContext('substances', item, metadata);
  }

  getReactantsTemlate() {
    const { metadata } = this.props;

    return this.props.stage.reactants.map((reactant, reactantIndex, reactants) => (
      <span className="stage-reactants" key={reactantIndex}>
        {reactant.id ? (
          <InnerHTML
            tag="a"
            href="null"
            tabIndex="0"
            onClick={(e) => {
              e.preventDefault();
              this.substanceClick(e, reactant, metadata);
            }}
            html={reactant.name}
            mode="escape"
            className="els-btn-link blue-compact"
          />
        ) : (
          <InnerHTML tag="span" html={reactant.name} mode="escape" />
        )}
        {!this.constructor.last(reactantIndex, reactants) && <>;&nbsp;</>}
      </span>
    ));
  }

  getReagentsTemplate() {
    const { metadata } = this.props;

    return (
      <>
        <b> With </b>
        {this.props.stage.reagents.map((reagent, reagentIndex, reagents) => (
          <span className="stage-reagents" key={reagentIndex}>
            {reagent.id ? (
              <InnerHTML
                tag="a"
                href="null"
                tabIndex="0"
                onClick={(e) => {
                  e.preventDefault();
                  this.substanceClick(e, reagent, metadata);
                }}
                html={reagent.name}
                mode="escape"
                className="els-btn-link blue-compact"
              />
            ) : (
              <InnerHTML tag="span" html={reagent.name} mode="escape" />
            )}
            {!this.constructor.last(reagentIndex, reagents) && <>;&nbsp;</>}
          </span>
        ))}
      </>
    );
  }

  getCatalystsTemplate() {
    const { metadata } = this.props;

    return (
      <>
        {this.props.stage.reactants || this.props.stage.reagents ? <>; </> : null}
        {this.props.stage.catalysts.map((catalyst, catalystIndex, catalysts) => (
          <span className="stage-catalyst" key={catalystIndex}>
            {catalyst.id ? (
              <InnerHTML
                tag="a"
                href="null"
                tabIndex="0"
                onClick={(e) => {
                  e.preventDefault();
                  this.substanceClick(e, catalyst, metadata);
                }}
                html={catalyst.name}
                mode="escape"
                className="els-btn-link blue-compact"
              />
            ) : (
              <InnerHTML tag="span" html={catalyst.name} mode="escape" />
            )}
            {!this.constructor.last(catalystIndex, catalysts) && <>;&nbsp;</>}
          </span>
        ))}
      </>
    );
  }

  getSolventsTemplate() {
    const { metadata } = this.props;

    return (
      <>
        <b> In </b>
        {this.props.stage.solvents.map((solvent, solventIndex, solvents) => (
          <span className="stage-solvents" key={solventIndex}>
            {solvent.id ? (
              <InnerHTML
                tag="a"
                href="null"
                tabIndex="0"
                onClick={(e) => {
                  e.preventDefault();
                  this.substanceClick(e, solvent, metadata);
                }}
                html={solvent.name}
                mode="escape"
                className="els-btn-link blue-compact"
              />
            ) : (
              <InnerHTML tag="span" html={solvent.name} mode="escape" />
            )}
            {!this.constructor.last(solventIndex, solvents) && <>;&nbsp;</>}
          </span>
        ))}
      </>
    );
  }

  getCIConditions() {
    return (
      <span className="conditions">
        {this.props.stage.atmosphere && (
          <>
            <InnerHTML tag="span" html={this.props.stage.atmosphere} mode="escape" />
            {'; '}
          </>
        )}

        {this.props.stage.reflux && (
          <>
            <InnerHTML tag="span" html={this.props.stage.reflux} mode="escape" />
            {'; '}
          </>
        )}

        {this.props.stage.totalVolume && (
          <>
            <InnerHTML tag="span" html={this.props.stage.totalVolume} mode="escape" />
            {'; '}
          </>
        )}

        {this.props.stage.molarity && (
          <>
            {' '}
            Molarity =
            <InnerHTML tag="span" html={this.props.stage.molarity} mode="escape" />
            mol/l
            {'; '}
          </>
        )}
      </span>
    );
  }

  getExperimentalProcedure() {
    // eslint-disable-next-line react/prop-types
    const id = `reaction-stage-procedure-${this.props.index}-${this.props.stageIndex}`;

    return (
      <div className="stage-experimental-procedure">
        <ToggleButton
          ariaControls={id}
          expanded={this.state.experimentalProcedureExpanded}
          /* eslint-disable-next-line react/no-access-state-in-setstate */
          toggleExpand={() => this.setState({ experimentalProcedureExpanded: !this.state.experimentalProcedureExpanded })}
          expandedLabel="Experiment Procedure"
          collapsedLabel="Experiment Procedure"
          isViewPreview={getValueByNs(this.props, 'metadata.isViewPreview')}
          className="els-btn-xs e2e-experiment-procedure"
        />
        {this.state.experimentalProcedureExpanded && (
          <div id={id} aria-expanded={this.state.experimentalProcedureExpanded}>
            <InnerHTML
              tag="div"
              className="stage-experimental-procedure--trust-html"
              html={this.props.stage.experimentalProcedure}
              extendedTags
            />
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="stages-row">
        {this.props.hasMultipleStages && <b>Stage #{this.props.stageIndex + 1}: </b>}
        {this.props.stage.reactants && this.getReactantsTemlate()}
        {this.props.stage.reagents && this.getReagentsTemplate()}
        {this.props.stage.catalysts && this.getCatalystsTemplate()}
        {this.props.stage.solvents && this.getSolventsTemplate()}
        <span className="conditions">
          {this.props.stage.temperature && (
            <>
              {' '}
              at <InnerHTML tag="span" html={this.props.stage.temperature} mode="escape" />
              &#8451;
              {'; '}
            </>
          )}
          {this.props.stage.pressure && (
            <>
              {' '}
              under <InnerHTML tag="span" html={this.props.stage.pressure} mode="escape" /> Torr
              {'; '}
            </>
          )}
          {this.props.stage.duration && (
            <>
              {' '}
              for <InnerHTML tag="span" html={this.props.stage.duration} mode="escape" />h{'; '}
            </>
          )}
          {this.props.stage.phValue && (
            <>
              {' '}
              pH=
              <InnerHTML tag="span" html={this.props.stage.phValue} mode="escape" />
              {'; '}
            </>
          )}
          {this.props.stage.solidPhase && (
            <>
              <InnerHTML tag="span" html={` ${this.props.stage.solidPhase}`} mode="escape" />
              {'; '}
            </>
          )}
          {this.props.stage.subjects &&
            this.props.stage.subjects.map((subject, subjectIndex) => (
              <React.Fragment key={subjectIndex}>
                <InnerHTML tag="span" key={subjectIndex} html={` ${subject}`} mode="escape" />
                {'; '}
              </React.Fragment>
            ))}
          {this.props.stage.prototypes &&
            this.props.stage.prototypes.map((prototype, prototypeIndex) => (
              <React.Fragment key={prototypeIndex}>
                <InnerHTML tag="span" key={prototypeIndex} html={` ${prototype}`} mode="escape" />
                {'; '}
              </React.Fragment>
            ))}
          {this.props.stage.name && (
            <>
              <InnerHTML tag="span" html={` ${this.props.stage.name}`} mode="escape" />
              {'; '}
            </>
          )}
          {this.props.stage.types &&
            this.props.stage.types.map((type, typeIndex) => (
              <React.Fragment key={typeIndex}>
                <InnerHTML tag="span" key={typeIndex} html={` ${type}`} mode="escape" />
                {'; '}
              </React.Fragment>
            ))}
          {this.props.stage.conditions &&
            this.props.stage.conditions.map((condition, conditionIndex) => (
              <React.Fragment key={conditionIndex}>
                <InnerHTML tag="span" key={conditionIndex} html={` ${condition}`} mode="escape" />
                {'; '}
              </React.Fragment>
            ))}
          {this.props.stage.comments &&
            this.props.stage.comments.map((comment, commentIndex) => (
              <React.Fragment key={commentIndex}>
                <InnerHTML tag="span" key={commentIndex} html={` ${comment}`} mode="escape" />
                {'; '}
              </React.Fragment>
            ))}
        </span>
        {this.props.isCIDatabase && this.getCIConditions()}
        {this.props.isCIDatabase && this.getExperimentalProcedure()}
      </div>
    );
  }
}

ReactionStageDetailComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  stage: PropTypes.object.isRequired,
  stageIndex: PropTypes.number.isRequired,
  hasMultipleStages: PropTypes.bool,
  isCIDatabase: PropTypes.bool,
};
